import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { Activity, UserPlus, Edit3, Trash2 } from "lucide-react";

const iconFor = (a) => a === "create" ? <UserPlus className="w-4 h-4 text-[#2C4230]" /> : a === "delete" ? <Trash2 className="w-4 h-4 text-red-700" /> : <Edit3 className="w-4 h-4 text-[#D9822B]" />;
const OTHER = {
  validate_member: "a validé le compte de", revoke_member: "a révoqué le compte de", block_member: "a bloqué le compte de",
  unblock_member: "a réactivé le compte de", password_changed: "a changé son mot de passe", password_reset: "a réinitialisé son mot de passe",
  merge: "a rattaché une fiche provisoire à", contribution: "a proposé un complément pour",
};
const otherLabel = (a) => OTHER[a] || (a?.startsWith("role_change") ? `a changé le rôle (${a.split(":")[1]}) de` : a?.startsWith("status:") ? "a changé le statut de" : a?.startsWith("contribution:") ? "a examiné une proposition pour" : "a modifié");

export const ActivityPage = () => {
  const { API } = useAuth();
  const { t } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await axios.get(`${API}/activity`);
      setItems(data);
    })();
  }, [API]);

  const label = (a) => a === "create" ? t("created") : a === "update" ? t("updated") : a === "delete" ? t("deleted") : otherLabel(a);

  return (
    <div className="max-w-4xl mx-auto px-6 sm:px-10 py-10" data-testid="activity-page">
      <div className="label-uppercase text-[#993D22] mb-2">{t("activity")}</div>
      <h1 className="font-serif-heritage text-5xl text-[#261911] mb-8">{t("recentActivity")}</h1>

      {items.length === 0 ? (
        <div className="heritage-card p-10 text-center text-[#6E5B4F]">
          <Activity className="w-10 h-10 mx-auto text-[#D9822B] mb-3" />
          <p className="font-serif-heritage text-xl">{t("noPersons")}</p>
        </div>
      ) : (
        <ul className="space-y-3 stagger">
          {items.map((it) => (
            <li key={it.id} className="heritage-card p-4 flex items-center gap-4" data-testid={`activity-${it.id}`}>
              <div className="w-10 h-10 rounded-full bg-[#F0E6D8] flex items-center justify-center shrink-0">
                {iconFor(it.action)}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-[#261911]">
                  <span className="font-semibold">{it.user_name || "Anonyme"}</span>{" "}
                  <span className="text-[#6E5B4F]">{label(it.action)}</span>{" "}
                  <span className="font-serif-heritage text-lg text-[#993D22]">{it.person_name}</span>
                </div>
                <div className="label-uppercase text-[#6E5B4F] mt-1">
                  {new Date(it.at).toLocaleString()}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ActivityPage;
